import { AnalyticsEvent } from '../models';

export class GroupOrderPageLoadEvent implements AnalyticsEvent {
  name = 'GroupOrderPageLoadEvent';

  constructor(public readonly eventType?: string) {}
}